import React, { useState, useEffect, useCallback } from 'react';
import SempDayList from './SempDayList';
import SempDayForm from './SempDayForm';
import { Button, Alert } from 'react-bootstrap';

const API_URL = '/json/semp_api.php';

const SempDayMain = ({ parentPlan }) => {
    const [days, setDays] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [currentDay, setCurrentDay] = useState(null);

    const fetchDays = useCallback(async () => {
        if (!parentPlan || !parentPlan.semp_no) return;
        setLoading(true);
        try {
            const response = await fetch(`${API_URL}?action=list_days&semp_no=${parentPlan.semp_no}`);
            const result = await response.json();
            if (result.success) {
                setDays(result.data);
            } else {
                setError(result.message);
            }
        } catch (err) {
            setError('일정 데이터를 불러오는 중 오류가 발생했습니다.');
        }
        setLoading(false);
    }, [parentPlan]);

    useEffect(() => {
        fetchDays();
    }, [fetchDays]);

    const handleShowModal = (day = null) => {
        setCurrentDay(day);
        setShowModal(true);
    };

    const handleHideModal = () => {
        setShowModal(false);
        setCurrentDay(null);
    };

    const handleSave = async (dayData) => {
        const action = dayData.semp_seq_no ? 'update_day' : 'create_day';
        const creatorOrChanger = 'admin'; // TODO: Change to actual user ID

        const payload = {
            action,
            data: {
                ...dayData,
                semp_no: parentPlan.semp_no, // Ensure parent ID is associated
                creator: dayData.semp_seq_no ? dayData.creator : creatorOrChanger,
                changer: creatorOrChanger,
            }
        };

        try {
            const response = await fetch(API_URL, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            });
            const result = await response.json();
            if (result.success) {
                alert(result.message);
                handleHideModal();
                fetchDays();
            } else {
                setError(result.message);
            }
        } catch (err) {
            setError('저장 중 오류가 발생했습니다.');
        }
    };

    const handleDelete = async (semp_seq_no) => {
        if (window.confirm(`정말로 이 일정을 삭제하시겠습니까?`)) {
            try {
                const response = await fetch(API_URL, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ action: 'delete_day', semp_seq_no })
                });
                const result = await response.json();
                if (result.success) {
                    alert(result.message);
                    fetchDays();
                } else {
                    setError(result.message);
                }
            } catch (err) {
                setError('삭제 중 오류가 발생했습니다.');
            }
        }
    };

    return (
        <div>
            <div className="d-flex justify-content-end mb-3">
                <Button variant="primary" onClick={() => handleShowModal()}>
                    새 일정 추가
                </Button>
            </div>

            {error && <Alert variant="danger" onClose={() => setError(null)} dismissible>{error}</Alert>}

            {loading ? (
                <p>로딩 중...</p>
            ) : (
                <SempDayList days={days} onEdit={handleShowModal} onDelete={handleDelete} />
            )}

            {showModal && (
                <SempDayForm
                    show={showModal}
                    onHide={handleHideModal}
                    onSave={handleSave}
                    day={currentDay}
                />
            )}
        </div>
    );
};

export default SempDayMain;
